import { SignOutAction } from "../signOut/types";
import { User } from "../../../data/interfaces";

export enum SIGN_IN_TYPES {
  PENDING = "SIGN_IN_PENDING",
  COMPLETED = "SIGN_IN_COMPLETED",
  ADD_ERROR = "SIGN_IN_ADD_ERROR",
  CLEAR_ERROR = "SIGN_IN_CLEAR_ERROR",
}

interface Pending {
  type: SIGN_IN_TYPES.PENDING;
}

interface Completed {
  type: SIGN_IN_TYPES.COMPLETED;
  payload: User;
}

interface AddError {
  type: SIGN_IN_TYPES.ADD_ERROR;
  payload: string;
}

interface ClearError {
  type: SIGN_IN_TYPES.CLEAR_ERROR;
}

export type SignInAction = Pending | Completed | AddError | ClearError | SignOutAction;
